import {HYDRATE} from 'next-redux-wrapper';
import {THEME_CONSTANTS} from '../actions/ThemeActions';

const THEME_INITIATE_STATE = {
    navCollapsed: false,
    theme: null,
    layoutSet: false,
    mobileView: null,
    tabletView: null,
    desktopView: null,
    showDrawer: false,
    showSupportDrawer: false,
    showNotificationDrawer: false,
    mobileModalWidth: '100%',
    desktopModalWidth: '35%',
};

export default function(state = THEME_INITIATE_STATE, action) {
    switch (action.type) {

        case HYDRATE:
            return {...state, ...action.payload.Alert};

        case THEME_CONSTANTS.CHANGE_DRAWER:
            return {
                ...state,
                ...action.payload
            };

        case THEME_CONSTANTS.CHANGE_DEVICE_WIDTH:
            return {
                ...state,
                ...action.payload
            };

        case THEME_CONSTANTS.CHANGE_THEME:
            return {
                ...state,
                ...action.payload
            };

        default:
            return state;
    }
}